import React, { useState } from 'react';
import { scrollToId } from './Navbar';
import LegalModal from './LegalModal';

export default function Footer() {
  const [legal, setLegal] = useState(null);

  return (
    <footer className="border-t border-[#c9c3b6]/60 bg-[#f4f1eb]">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10 md:gap-8">
          <div className="md:col-span-2">
            <div className="font-serif-display text-[22px] tracking-[0.35em] uppercase">
              Riva Build Group
            </div>
            <p className="mt-6 max-w-sm text-[13px] leading-relaxed text-[#5a5852]">
              A Los Angeles construction firm crafting distinctive residences
              and private developments, where architectural vision meets
              precise execution.
            </p>
          </div>

          <div>
            <div className="font-sans-ui text-[10px] text-[#5a5852] mb-5 tracking-[0.28em]">
              Explore
            </div>
            <ul className="space-y-3 text-[13px]">
              {[
                ['Custom Homes', 'custom-homes'],
                ['Developments', 'developments'],
                ['Releases', 'releases'],
                ['New Build', 'new-build'],
                ['Renovations', 'renovations'],
                ['Vision', 'vision'],
                ['Contact', 'contact'],
              ].map(([l, id]) => (
                <li key={id}>
                  <button
                    onClick={() => scrollToId(id)}
                    className="underline-reveal text-left"
                  >
                    {l}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <div className="font-sans-ui text-[10px] text-[#5a5852] mb-5 tracking-[0.28em]">
              Contact
            </div>
            <ul className="space-y-3 text-[13px]">
              <li>
                <a href="mailto:info@rivabuildgroup.com" className="underline-reveal">
                  info@rivabuildgroup.com
                </a>
              </li>
              <li className="text-[#5a5852]">+1 (310) 555 0188</li>
              <li className="text-[#5a5852]">
                9200 Sunset Boulevard
                <br />
                West Hollywood, CA 90069
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-[#c9c3b6]/60 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <div className="font-sans-ui text-[10px] text-[#5a5852] tracking-[0.28em]">
            &copy; {new Date().getFullYear()} Riva Build Group. All rights reserved.
          </div>
          <div className="font-sans-ui text-[10px] text-[#5a5852] flex gap-6 tracking-[0.28em]">
            <button onClick={() => setLegal('privacy')} className="underline-reveal">
              Privacy
            </button>
            <button onClick={() => setLegal('terms')} className="underline-reveal">
              Terms
            </button>
            <button onClick={() => setLegal('licensing')} className="underline-reveal">
              Licensing
            </button>
          </div>
        </div>
      </div>
      <LegalModal kind={legal} onClose={() => setLegal(null)} />
    </footer>
  );
}
